export interface EmployeeDocumentType {
    key: string;
    label: string;
    icon: string;
    iconBg: string;
    required: boolean;
}

/**
 * Fixed set of hiring-document slots (Documentación de contratación).
 * Order and keys must match App\Support\EmployeeDocumentTypes on the backend.
 */
export const EMPLOYEE_DOCUMENT_TYPES: EmployeeDocumentType[] = [
    { key: 'birth_certificate', label: '1. Partida de nacimiento', icon: 'doc-file-text.svg', iconBg: '#e1f0ff', required: true },
    { key: 'ine_front', label: '2. INE (Frente)', icon: 'doc-user.svg', iconBg: '#fff5e6', required: true },
    { key: 'ine_back', label: '3. INE (Reverso)', icon: 'doc-user.svg', iconBg: '#e1f0ff', required: true },
    { key: 'social_security_number', label: '4. Número de seguro social', icon: 'doc-shield.svg', iconBg: '#def5d9', required: true },
    { key: 'curp', label: '5. CURP', icon: 'doc-file-text.svg', iconBg: '#f3e8ff', required: true },
    { key: 'tax_status_certificate', label: '6. Constancia de situación fiscal (RFC)', icon: 'doc-landmark.svg', iconBg: '#fce7f3', required: true },
    { key: 'education_proof', label: '7. Comprobante de estudios', icon: 'doc-graduation-cap.svg', iconBg: '#e0f2fe', required: true },
    { key: 'address_proof', label: '8. Comprobante de domicilio', icon: 'doc-home.svg', iconBg: '#f3e8ff', required: true },
    { key: 'employment_references', label: '9. Constancias laborales', icon: 'doc-briefcase.svg', iconBg: '#e0f2fe', required: true },
    { key: 'criminal_record_check', label: '10. Antecedentes no penales actualizados', icon: 'doc-file-badge.svg', iconBg: '#e1f0ff', required: true },
    { key: 'medical_certificate', label: '11. Certificado médico laboral', icon: 'doc-heart.svg', iconBg: '#fce7f3', required: true },
    { key: 'bank_account', label: '12. Cuenta bancaria (CLABE y nombre)', icon: 'doc-credit-card.svg', iconBg: '#e1f0ff', required: true },
    { key: 'spouse_birth_certificate', label: '13. Acta de nacimiento de cónyuge', icon: 'doc-file-text.svg', iconBg: '#f3e8ff', required: false },
    { key: 'marriage_certificate', label: '14. Acta de matrimonio', icon: 'doc-heart.svg', iconBg: '#f3e8ff', required: false },
    { key: 'infonavit_withholding_notice', label: '15. Aviso de retención de INFONAVIT', icon: 'doc-percent.svg', iconBg: '#fff5e6', required: false },
];

export function getEmployeeDocumentType(key: string): EmployeeDocumentType | undefined {
    return EMPLOYEE_DOCUMENT_TYPES.find(t => t.key === key);
}
